<script>
    import LibLoader from "./LibLoader.svelte";
    import ProgressBar from "@okrad/svelte-progressbar"

    function onLoaded() {
        startVolumetricObjectViewer(loadingCallback);
    }

    export const series = [0];

    function loadingCallback(x) {
      series[0] = isNaN(x) ? 0 : x * 100;
    }

</script>

<LibLoader src="js/snerg-viewer.js" on:loaded={onLoaded}/>

<div class="truck" class:hidden={series[0] >= 100}>
  <ProgressBar
  style='custom'
  {series}
  bgColor="rgba(0, 0, 0, 0.2)"
  textSize=80
  path='M87 0 43 1v59H27v2a88 88 0 0 1-3 6l-2 5-2 5-2 5-2 5a147 147 0 0 0-4 9l-1 13c0 12 0 12 2 11l4-1 97-1 96 1c7 2 11 5 15 10l1 2h11v-16l4 2 2 1 1 2 2 12c3 10 9 18 18 27 5 5 14 12 19 14h17l-2-3a164 164 0 0 1-31-98l-8 8c-5 7-9 13-12 21l-1 2-2-1-3-1-3-3-1-20V60h-19l-2-2c-3-3-5-3-11-3-7 0-8 0-12 3l-1 2h-13V48c0-12 0-13-3-14-2-2-5-2-7 1l-2 13v12h-11c-13 0-13 0-13-3a211 211 0 0 0-6-26 92 92 0 0 0-2-12l-1-3a527 527 0 0 1-3-13l-1-3H87zm2 17a1029 1029 0 0 1 31 1l1 3 1 5 1 6 1 4 1 5 3 13 2 12 1 7 2 6v5l-3-1-12-5-6-2-6-2-3-2-3-1-3-1-3-2-4-1-3-1-3-2-3-1a213 213 0 0 1-23-9V17h31zm26 106H20c-6 1-12 5-16 12l-4 9v8l2 6c1 5 2 6 4 8 3 4 7 7 13 8h189a25 25 0 0 0 18-26c0-6 0-7-2-11s-6-8-10-11c-5-3 5-3-99-3zm-88 17 9 1c6 3 7 11 1 15l-1 1h-9l-11-1c-3-2-4-3-4-7 0-3 0-4 2-5 2-4 4-4 13-4zm57 0 10 1c6 3 6 11 1 15l-2 1H75l-1-1c-5-3-5-10-2-13 2-3 4-3 12-3zm58 0 9 1c6 3 7 9 3 14l-4 2a97 97 0 0 1-17 0l-3-2c-4-4-3-12 3-14l9-1zm58 0 9 1c4 2 6 6 5 10-1 3-3 5-6 6h-17l-3-2c-5-4-3-11 2-14l10-1z'
  width=300
  height=175
/>
</div>
<div id="info" class="info" class:hidden={series[0] < 100}>
  Frames per second: <div id="fpsdisplay">0.0</div>
</div>


<div id="viewspacecontainer">
  
  <div id="Loading" class="hidden">
    <h4>
    [Loading]
    <span id="texturergbprogress">RGBA images: 0/?</span>,
    <span id="texturefeaturesprogress">feature images: 0/?</span>
    </h4>
  </div>
  <div class="viewspace" id="viewspace">
    <div id="view">
      <canvas/>
    </div>
  </div>
</div>

<style>
  #viewspacecontainer {
    position: absolute;
    overflow: hidden;
  }

  .hidden {
    display: none;
  }

  .truck {
    position: absolute;
    z-index: 10;
    align-self: center;
  }

  canvas, div {
    outline: none;
  }

  .info {
    position: absolute;
    left: 10%;
    bottom: 0;
    z-index: 10;
    font-size: .7rem;
    color: white;
    line-height: normal;
    text-transform: uppercase;
    background: rgba(0, 0, 0, 0.2);
    padding: 0.4rem;
    margin: 0.4rem;
  }
  
  #fpsdisplay {
    font-size: 1.5rem;
  }
</style>